var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 1.66669C5.39734 1.66669 1.6665 5.39752 1.6665 10C1.6665 14.6025 5.39734 18.3334 9.99984 18.3334C14.6023 18.3334 18.3332 14.6025 18.3332 10C18.3332 5.39752 14.6023 1.66669 9.99984 1.66669ZM12.1548 13.3334L9.41067 10.5892C9.254 10.4325 9.1665 10.2209 9.1665 10V5.83335C9.1665 5.37335 9.53984 5.00002 9.99984 5.00002C10.4598 5.00002 10.8332 5.37335 10.8332 5.83335V9.65502L13.3332 12.155C13.6582 12.48 13.6582 13.0084 13.3332 13.3334C13.0082 13.6584 12.4798 13.6584 12.1548 13.3334Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.a438607f9123ff6945fca2b41116445b.svg";
export { ForwardRef as ReactComponent };